<template>
  <div>
    <Drag :class="{ 'no-show': isDisabled }" @drag-start="dragStart" @dragging="dragging" @drag-stop="dragStop">
      <v-icon class="grabbable">mdi-drag</v-icon>
    </Drag>
    <slot />
  </div>
</template>

<script>
import { propToBool } from '../../../libraries/common';
import Drag from './Drag.vue'
export default {
  components: { Drag },
  props: ['disabled'],
  data() {
    return {
      draggingElement: null,
      startPosition: null,
    };
  },
  computed: {
    isDisabled() {
      return propToBool(this.disabled);
    },
  },
  methods: {
    dragStart() {
      var element = this.$el;
      this.draggingElement = element.cloneNode(true);
      this.draggingElement.style.position = 'fixed';

      var icon = this.draggingElement.querySelector('.grabbable')
      icon.classList.remove('grabbable')
      this.draggingElement.style.cursor = 'grabbing';

      const { x, y, width, height } = element.getBoundingClientRect();

      this.draggingElement.style.width = `${width}px`;
      this.draggingElement.style.height = `${height}px`;
      this.draggingElement.style.left = `${x}px`;
      this.draggingElement.style.top = `${y}px`;
      this.draggingElement.style.zIndex = 9999;
      this.$el.appendChild(this.draggingElement);

      this.startPosition = { x, y: y - height };
      this.$emit('drag-start');
    },
    dragging(event) {
      if (!this.draggingElement) return;
      this.draggingElement.style.left = `${event.x + this.startPosition.x}px`;
      this.draggingElement.style.top = `${event.y + this.startPosition.y + this.draggingElement.offsetHeight}px`;
    },
    dragStop() {
      if (!this.draggingElement) return;
      this.draggingElement.parentElement.removeChild(this.draggingElement);
      this.draggingElement = null;
      this.$emit('drag-stop');
    },
    propToBool,
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisDragItem'] = this;
  },
}
</script>

<style lang="scss" scoped>
.grabbable {
  cursor: grab;
}
</style>